/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {
  LayoutDashboard,
  MapPin,
  Activity,
  Building2,
  Boxes,
  FolderKanban,
  User,
  Users,
  Briefcase,
  ShieldCheck,
  ScrollText,
} from 'lucide-react'
import {SidebarMenuItem} from './SidebarMenuItem'
import {Menus} from '../../../../../app/helpers/MenuAccessControl'
import {useAuth} from '../../../../../app/modules/auth'
import {TOKENS} from '../../../../../app/components/design-system'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()

  return (
    <>
      <SidebarMenuItem
        menuId={Menus.dashboard.id}
        to='/dashboard'
        IconComp={LayoutDashboard}
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
      />
      {!!currentUser?.last_company_show_menu_map &&
        <SidebarMenuItem
          menuId={Menus.map.id}
          to='/map'
          IconComp={MapPin}
          title={intl.formatMessage({id: 'MENU.MAP'})}
        />
      }
      {!!currentUser?.last_company_show_menu_sensors &&
        <SidebarMenuItem
          menuId={Menus.sensors.id}
          to='/sensors'
          IconComp={Activity}
          title={intl.formatMessage({id: 'MENU.SENSORS'})}
        />
      }
      <div className='menu-item'>
        <div className='menu-content pt-6 pb-2 px-3'>
          <span style={{
            fontSize: 9,
            fontWeight: 700,
            letterSpacing: 0.8,
            textTransform: 'uppercase',
            color: TOKENS.color.muted,
          }}>Cadastros</span>
        </div>
      </div>
      <SidebarMenuItem
        menuId={Menus.companies.id}
        to='/apps/companies-management'
        title='Empresas'
        IconComp={Building2}
      />
      <SidebarMenuItem
        menuId={Menus['measuring_boxes'].id}
        to='/apps/measuring-box-management'
        title='Caixas'
        IconComp={Boxes}
      />
      <SidebarMenuItem
        menuId={Menus.projects.id}
        to='/apps/projects-management/projects'
        title='Projetos'
        IconComp={FolderKanban}
      />
      <SidebarMenuItem
        menuId={14}
        to='/apps/operators-management'
        title='Operadores'
        IconComp={User}
      />
      <SidebarMenuItem
        menuId={Menus.coordinators.id}
        to='/apps/coordinators-management'
        title='Coordenadores'
        IconComp={Users}
      />
      <SidebarMenuItem
        menuId={Menus.managers.id}
        to='/apps/managers-management'
        title='Gerentes'
        IconComp={Briefcase}
      />
      <SidebarMenuItem
        menuId={Menus.administrators.id}
        to='/apps/administrators-management'
        title='Administradores'
        IconComp={ShieldCheck}
      />
      <SidebarMenuItem
        menuId={Menus.logs.id}
        to='/apps/logs-management/logs'
        title='Históricos'
        IconComp={ScrollText}
      />
    </>
  )
}

export {SidebarMenuMain}
